import { useMutation } from '@apollo/react-hooks';
import { trackingEventsApi } from '../api';

export const useTrackingEvents = () => {

  const [createTrackingEvent, { loading: isTrackingEventLoading }] = useMutation(
    trackingEventsApi.createTrackingEvent
  );

  return {
    createTrackingEvent,
    isTrackingEventLoading,
  };
};
